import React from 'react';

const LoadingSpinner = ({ message = 'Loading...' }) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '300px',
      width: '100%'
    }}>
      {/* Rotating gear/spinner icon */}
      <div style={{
        width: '48px',
        height: '48px',
        position: 'relative'
      }}>
        <svg
          viewBox="0 0 24 24"
          style={{
            width: '100%',
            height: '100%',
            animation: 'spin 1.5s linear infinite',
            color: '#0ea5e9'
          }}
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          {/* Gear/asterisk shape */}
          <line x1="12" y1="2" x2="12" y2="6" strokeLinecap="round"/>
          <line x1="12" y1="18" x2="12" y2="22" strokeLinecap="round"/>
          <line x1="4.93" y1="4.93" x2="7.76" y2="7.76" strokeLinecap="round"/>
          <line x1="16.24" y1="16.24" x2="19.07" y2="19.07" strokeLinecap="round"/>
          <line x1="2" y1="12" x2="6" y2="12" strokeLinecap="round"/>
          <line x1="18" y1="12" x2="22" y2="12" strokeLinecap="round"/>
          <line x1="4.93" y1="19.07" x2="7.76" y2="16.24" strokeLinecap="round"/>
          <line x1="16.24" y1="7.76" x2="19.07" y2="4.93" strokeLinecap="round"/>
        </svg>
      </div>

      {/* Static text below - NOT rotating */}
      <p style={{
        marginTop: '16px',
        color: '#64748b',
        fontSize: '14px',
        fontWeight: '400'
      }}>
        {message}
      </p>

      {/* Animation keyframes */}
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner;
